import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'

import GlobalLoader from 'app/components/Loaders/GlobalLoader'
import { ADMIN, MULTI_ADMIN, SUPER_ADMIN, USER } from 'app/constants/roles'
import { ERRORS } from 'store/entities/analytics/consts'

class AsyncRouter extends Component {
  static propTypes = {
    role: PropTypes.oneOf([USER, ADMIN, SUPER_ADMIN, MULTI_ADMIN]),
  }

  state = {
    CurrentRouter: null,
    error: null,
    isLoading: false,
  }

  componentDidMount() {
    const { role } = this.props
    this.switchRole(role)
    this.props.fetchCountriesCodes()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.role !== this.props.role) {
      this.switchRole(this.props.role)
      this.props.history.push('/')
    }
  }

  switchRole(role) {
    this.setState({ isLoading: true })
    let getRouter
    switch (role) {
      case ADMIN:
        getRouter = import(/* webpackChunkName: "admin" */ './AdminRouter')
        break
      case MULTI_ADMIN:
      case SUPER_ADMIN:
        getRouter = import(/* webpackChunkName: "super-admin" */ './SuperAdminRouter')
        break
      case USER:
        getRouter = import(/* webpackChunkName: "user" */ './UserRouter')
        break
      default:
        getRouter = import(/* webpackChunkName: "guest" */ './GuestRouter')
        break
    }
    getRouter
      .then(({ default: CurrentRouter }) => this.setState({ CurrentRouter, isLoading: false }))
      .catch(error => {
        this.props.sendError({
          type: ERRORS.ASYNC_ROUTER,
          error,
        })
        Sentry.withScope(scope => {
          scope.setExtra('where error was happen', 'AsyncRouter')
          Sentry.captureException(error)
        })
        return this.setState({ error, isLoading: false })
      })
  }

  render() {
    const { CurrentRouter, isLoading } = this.state

    return CurrentRouter && !isLoading ? <CurrentRouter /> : <GlobalLoader />
  }
}

export default AsyncRouter
